// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"9dc2b979","177":"03334837","321":"2673a000","326":"7ce230dc","682":"89b288c6"}[chunkId] + ".chunk.js";
};